import React from 'react';

export default function Table({ columns, data, loading, emptyMessage = 'No records found' }) {
  if (loading) return (
    <div className="flex flex-col items-center gap-3 py-16 text-gray-400">
      <div className="w-9 h-9 border-[3px] border-gray-200 border-t-hajj-gold rounded-full animate-spin" />
      <p className="text-sm">Loading...</p>
    </div>
  );

  return (
    <div className="overflow-x-auto rounded-xl border border-gray-100 -webkit-overflow-scrolling-touch">
      <table className="min-w-[580px] w-full border-collapse bg-hajj-cream">
        <thead>
          <tr className="bg-hajj-dark">
            {columns.map(col => (
              <th
                key={col.key}
                className="px-4 py-3 text-left text-[11px] font-semibold text-white/80 uppercase tracking-wider whitespace-nowrap"
                style={{ width: col.width }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-14 text-gray-400 italic text-sm">
                {emptyMessage}
              </td>
            </tr>
          ) : data.map((row, i) => (
            <tr key={row._id || i} className="border-b border-[#e2ddd5] last:border-0 hover:bg-white/60 transition-colors">
              {columns.map(col => (
                <td key={col.key} className="px-4 py-3 text-sm text-gray-700 align-middle">
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
